import styles from './SimpleButtonAccordion.scss';

import cx from 'classnames';
import React from 'react';

import { Accordion } from '../Accordion';
import { AccordionItem, AccordionItemId, OpenSections } from '../models';
import { SimpleButtonAccordionIcon } from './SimpleButtonAccordionIcon';

enum ButtonPosition {
  Left,
  Right,
  None,
}

interface SimpleButtonAccordionProps {
  items: AccordionItem[];
  buttonPosition?: ButtonPosition;
  className?: string;
  allowMultipleOpen?: boolean;
  alwaysHaveOneItemOpen?: boolean;
}

const buttonClass = {
  [ButtonPosition.None]: styles.accordionButtonNone,
  [ButtonPosition.Left]: styles.accordionButtonLeft,
  [ButtonPosition.Right]: styles.accordionButtonRight,
};

const getAccordionRowsJSX = (items: AccordionItem[], onToggled: (id: AccordionItemId) => void, openSections: OpenSections, buttonClass: string) => {
  return items.map((item, index) => (
    <React.Fragment key={item.id}>
      <Accordion.Header
        itemId={item.id}
        defaultOpen={item.defaultOpen}
        onToggled={onToggled}
        openSections={openSections}
        className={cx(item.headerClassName, styles.header)}
      >
        <SimpleButtonAccordionIcon open={openSections[index]} className={buttonClass} />
        {item.title}
      </Accordion.Header>
      <Accordion.Body
        itemId={item.id}
        openSections={openSections}
        className={styles.body}
      >
        {item.body}
      </Accordion.Body>
    </React.Fragment>
  ));
};

const SimpleButtonAccordion: React.FC<SimpleButtonAccordionProps> = props => {
  const { allowMultipleOpen, buttonPosition = ButtonPosition.Right, items, className, alwaysHaveOneItemOpen } = props;

  return (
    <Accordion
      allowMultipleOpen={Boolean(allowMultipleOpen)}
      className={cx(styles.simpleButtonAccordion, className)}
      alwaysHaveOneItemOpen={alwaysHaveOneItemOpen}
    >
      {(onToggled, openSections) => (
        getAccordionRowsJSX(items, onToggled, openSections, buttonClass[buttonPosition])
      )}
    </Accordion>
  );
};

export {
  SimpleButtonAccordion,
  ButtonPosition,
};
